/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MainDataVersion,
    MainDataVersionFromJSON,
    MainDataVersionFromJSONTyped,
    MainDataVersionToJSON,
    OperationResultSummary,
    OperationResultSummaryFromJSON,
    OperationResultSummaryFromJSONTyped,
    OperationResultSummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface MainDataResOperationResultSummary
 */
export interface MainDataResOperationResultSummary {
    /**
     * 
     * @type {MainDataVersion}
     * @memberof MainDataResOperationResultSummary
     */
    version: MainDataVersion;
    /**
     * 
     * @type {OperationResultSummary}
     * @memberof MainDataResOperationResultSummary
     */
    data?: OperationResultSummary;
    /**
     * 
     * @type {string}
     * @memberof MainDataResOperationResultSummary
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResOperationResultSummary
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResOperationResultSummary
     */
    total?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResOperationResultSummary
     */
    limit?: number | null;
}

export function MainDataResOperationResultSummaryFromJSON(json: any): MainDataResOperationResultSummary {
    return MainDataResOperationResultSummaryFromJSONTyped(json, false);
}

export function MainDataResOperationResultSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainDataResOperationResultSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': MainDataVersionFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : OperationResultSummaryFromJSON(json['data']),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MainDataResOperationResultSummaryToJSON(value?: MainDataResOperationResultSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': MainDataVersionToJSON(value.version),
        'data': OperationResultSummaryToJSON(value.data),
        'error': value.error,
        'offset': value.offset,
        'total': value.total,
        'limit': value.limit,
    };
}


